import { isPlatformRoute, isPlatformRole } from "./isPlatformRoute";

/** Platform shell chrome (dark bg, no footer) — requires staff/partner role */
export function usesPlatformChrome(pathname = "", role) {
  if (!role || role === "User" || !isPlatformRole(role)) return false;
  if (pathname === "/events") return true;
  return isPlatformRoute(pathname);
}
